const publicBuildInfo = {
  "packageVersion": "0.1.0"
};

export default publicBuildInfo;
